import { render, staticRenderFns } from "./PxCalculoNivelDependencia.vue?vue&type=template&id=95331a8e&"
import script from "./PxCalculoNivelDependencia.vue?vue&type=script&lang=js&"
export * from "./PxCalculoNivelDependencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports